import { Button, IconTrash, Select, Stack } from '@vtex/admin-ui'
import { Select as FormSelect } from '@vtex/admin-ui-form'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import type { SCOPE_RESTRICTION_TYPE } from 'typings'
import { useFormStateContext } from '../../../providers'
import { Full } from '../../Full'
import { SCOPE_OPERATORS, SCOPE_SELECTORS } from './constants'

interface Props {
  baseName: string
  type: SCOPE_RESTRICTION_TYPE
  options: Array<{ id: SCOPE_RESTRICTION_TYPE; labelId: string }>
  onChangeType: (id: SCOPE_RESTRICTION_TYPE) => void
  onDelete: (id: SCOPE_RESTRICTION_TYPE) => void
}

export function ScopeRestrictionEditor(props: Props) {
  const { type, options, onChangeType, onDelete, baseName } = props
  const { form, readOnly } = useFormStateContext()
  const { formatMessage } = useIntl()

  const [restrictionType, setRestrictionType] =
    useState<SCOPE_RESTRICTION_TYPE>(type)

  const handleTypeChange = (type: SCOPE_RESTRICTION_TYPE) => {
    setRestrictionType(type)

    onChangeType(type)
  }

  const scopeOperators = SCOPE_OPERATORS[restrictionType]
  const scopeSelector = SCOPE_SELECTORS[restrictionType]

  return (
    <Stack
      fluid
      space="$space-4"
      data-testid={`scope-restriction-editor-${type}`}
    >
      <Stack fluid direction="row" space="$space-4">
        <Full>
          <Select
            value={restrictionType}
            aria-label={formatMessage({
              id: 'admin/promotions.form.scope.rule.type',
            })}
            onChange={(event) =>
              handleTypeChange(event.target.value as SCOPE_RESTRICTION_TYPE)
            }
            disabled={readOnly}
          >
            {options.map(({ id, labelId }) => (
              <option value={id} key={id}>
                <FormattedMessage id={labelId} />
              </option>
            ))}
          </Select>
        </Full>

        <Full>
          <FormSelect
            name={`${baseName}.${restrictionType}.operator`}
            state={form}
            aria-label={formatMessage({
              id: 'admin/promotions.form.scope.rule.operator',
            })}
            // @ts-expect-error Property 'disabled' does not exist on type 'IntrinsicAttributes & InheritedProps$4 & FormFieldProps' (missing types)
            disabled={readOnly}
          >
            {Object.entries(scopeOperators).map(([operatorType, labelId]) => (
              <option value={operatorType} key={operatorType}>
                <FormattedMessage id={labelId} />
              </option>
            ))}
          </FormSelect>
        </Full>
      </Stack>

      {scopeSelector}

      <div>
        <Button
          variant="neutralTertiary"
          onClick={() => onDelete(type)}
          icon={<IconTrash />}
          disabled={readOnly}
        >
          <FormattedMessage id="admin/promotions.form.scope.remove-rule" />
        </Button>
      </div>
    </Stack>
  )
}
